import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to persist the current view state.
 */
export class PersistStateCommandBody implements CommandBody {
  /**
   * Name of the view that the state will be persisted.
   */
  view: string;

  /**
  * Parameters to be persisted.
  */
  params?: any;
}
